import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import {
	CompetenceSSIAD,
	CompetenceSESSAD,
	CompetenceSAAD
} from 'src/app/shared/enums/competence.enum';
import { Prestation } from 'src/app/shared/models/prestation';
import { Employee } from 'src/app/shared/models/employee/employee';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';
import { SuiviPrestation } from 'src/app/shared/models/suiviPrestation';

@Component({
	selector: 'app-modal-content',
	templateUrl: './prestation-modal-detail-suiviPrestation.component.html',
	styleUrls: ['./prestation-modal-detail-suiviPrestation.component.scss']
})
export class PrestationModalDetailSuiviPrestationComponent implements OnInit {
	/**
	 * Prestation, transmit par le service Modal de ngx dans PrestationModalDetailSuiviPrestationComponent
	 */
	prestation: Prestation;

	/**
	 * MissionRequest, transmit par le service Modal de ngx dans PrestationModalDetailSuiviPrestationComponent
	 */
	suiviPrestation: SuiviPrestation;

	competences;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	uniqueEmployeeOfMission: Employee;

	LABEL_INTERVENTION: string;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService
	) {}

	ngOnInit(): void {

	}

	get LABEL_INTERVENANT() {
		return this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_INTERVENANT
		);
	}

	get LABEL_BENEFICIAIRE() {
		return this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_BENEFICIAIRE
		);
	}

	getEmployeeOfMission() {
		const employeeName = this.uniqueEmployeeOfMission
			? this.uniqueEmployeeOfMission.firstName +
			  ' ' +
			  this.uniqueEmployeeOfMission.lastName
			: 'Aucun';
		return employeeName;
	}

	
}
